import { render } from "./pricing-index.vue?vue&type=template&id=4c4eb0cb"
import script from "./pricing-index.vue?vue&type=script&lang=js"
export * from "./pricing-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__